/* ============================================================
   CC- Küchenvorschau-Funnel — Danke-Seiten-Logik (Umbau 17.08.2026)
   Erstellt von Claude Code (cc-)
   - Motiv aus URL (?motiv=), Job aus (?job=) -> Vorschau-Polling + Reveal
   - PREISBLOCK: Maße aus /status (visible_width_cm etc.), Formel identisch
     zum Konfigurator; Konstanten + Sale-Zustand kommen zur Laufzeit von der
     ECHTEN Konfigurator-Seite des Motivs (fetch) — dieselbe Quelle, kein Drift.
   - MUSTER-BLOCK: Box 1 wird mit dem Vorschau-Motiv (Klassik Matt) vorbefüllt.
     Boxen/Labels/Preise/ATC/Repricing/Draft-Order laufen KOMPLETT über die
     geteilten Dateien der Muster-Seite (custom.js + sample-product-form.js).
   - Muster-Set, Gutschein und Countdown sind entfernt; offer_active/offer_until
     liefert das Backend weiter, die UI ignoriert sie (stillgelegt 17.08.2026).
   Daten: window.CC_DANKE (aus der Section gerendert)
   ============================================================ */
(function () {
  var root = document.querySelector('.cc-danke');
  if (!root) return;
  var cfg = window.CC_DANKE || { motifImages: {}, musterVariants: {}, configUrls: {} };

  // Zentrales Klick-Tracking: GTM dataLayer + Meta Pixel (Custom Event)
  function ccTrack(event, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', event, data || {}); } catch (e) {}
  }

  var motiv = null;
  try { motiv = new URLSearchParams(location.search).get('motiv'); } catch (e) {}
  motiv = (motiv && motiv.trim()) ? motiv.trim() : null;
  var imgUrl = (motiv && cfg.motifImages && cfg.motifImages[motiv]) ? cfg.motifImages[motiv] : null;
  var motifName = motiv || 'Dein Wunschmotiv';

  // --- Personalisierung ---
  var musterText = root.querySelector('[data-cc-muster-text]');
  if (musterText) musterText.textContent = musterText.textContent.replace('[Motiv]', motiv ? ('Dein Motiv „' + motiv + '"') : 'Dein Motiv');

  // ================= Status-Daten (Kontingent, Geschwister, Maße) =================
  var ccInfo = { retries: 0, reco: [], reason: '', sibs: [], mass: null };
  var ccRevealDone = false;
  var aktJob = null;
  try { aktJob = new URLSearchParams(location.search).get('job'); } catch (e) {}

  function ccStatusDaten(d) {
    if (!d) return;
    ccInfo.retries = d.retries_left || 0;
    ccInfo.reco = d.recommended_motifs || [];
    ccInfo.reason = d.motif_reason || '';
    ccInfo.sibs = d.siblings || [];
    // Maße für den Preisblock — nur wenn der Maßstab sicher ist (Briefing 3.4):
    // Kochfeld als Referenz, keine Eckküche. Im Zweifel: kein Preis.
    if (!ccInfo.mass && d.scale_reference === 'hob_60cm' && !d.corner_present) {
      var w = Number(d.visible_width_cm), h = Number(d.backsplash_height_cm);
      if (w > 0 && h > 0) { ccInfo.mass = { w: w, h: h }; ccPreisBlock(); }
    }
    ccUiUpdate();
  }

  // Kontingent kommt vom Server (retries_left); seit 17.08.2026 drei Generierungen
  // je E-Mail. GESAMT = genutzte + verbleibende, damit "X von Y" auch stimmt, wenn
  // das Limit im Backend spaeter anders gesetzt wird.
  function ccMotivText(n) {
    return n === 1 ? '1 Motiv' : n + ' Motive';
  }
  // Zwei Zeilen (Alwin 17.08.2026): erst das Gesamtangebot, dann was noch frei ist.
  // Gesamt = genutzte + verbleibende, damit es auch bei geaendertem Backend-Limit stimmt.
  function ccGesamtText() {
    var gesamt = Math.max(1, (ccInfo.sibs || []).length) + ccInfo.retries;
    return 'Du kannst ' + gesamt + 'x eine kostenlose Vorschau erstellen.';
  }
  function ccFreiText() {
    return 'Noch ' + ccInfo.retries + 'x verfügbar.';
  }

  function ccUiUpdate() {
    // Retry-Block: nur im Fertig-Zustand und nur solange der Server Kontingent meldet
    var retryP = root.querySelector('[data-cc-retry]');
    if (retryP) retryP.hidden = !(ccRevealDone && ccInfo.retries > 0);
    var retryTotal = root.querySelector('[data-cc-retry-total]');
    if (retryTotal && ccInfo.retries > 0) retryTotal.textContent = ccGesamtText();
    var retryCount = root.querySelector('[data-cc-retry-count]');
    if (retryCount && ccInfo.retries > 0) retryCount.textContent = ccFreiText();
    // Umschalter: ab zwei fertigen Vorschauen
    var wrap = root.querySelector('[data-cc-versions]');
    if (wrap) {
      if (ccRevealDone && ccInfo.sibs.length >= 2) {
        wrap.hidden = false;
        wrap.innerHTML = '';
        ccInfo.sibs.forEach(function (sib) {
          var b = document.createElement('button');
          b.type = 'button';
          if (sib.job === aktJob) b.className = 'is-active';
          b.innerHTML = '<img src="' + sib.url + '" alt=""><figcaption>' + (sib.motiv || '') + '</figcaption>';
          b.addEventListener('click', function () {
            if (sib.job === aktJob) return;
            window.location.href = location.pathname + '?motiv=' + encodeURIComponent(sib.motiv || '') + '&job=' + encodeURIComponent(sib.job);
          });
          wrap.appendChild(b);
        });
      } else {
        wrap.hidden = true;
      }
    }
  }

  // ================= Preisblock =================
  // Formel wie assets/config-product.js (dort verifiziert, sechs von sechs exakt):
  //   raw = BASE + AREA_FACTOR * area^EXPONENT - 5*H - 10*W ; preis = round(raw) + 0.90
  //   sale = preis * DISCOUNT (nur solange die Aktion läuft)
  // Die Vorschau zeigt immer Klassik Matt -> BASE 5, EXPONENT 0.8 (hart wie im
  // Konfigurator-JS). AREA_FACTOR und der Sale-Zustand ([data-final-sale-price],
  // gerendert nur bei settings.show_promotion) werden von der echten
  // Konfigurator-Seite des Motivs geholt — dieselbe Quelle wie der Konfigurator.
  // Scheitert der Abruf, erscheint KEIN Preis (lieber keiner als ein falscher).
  var preisGezeigt = false;
  function ccEuro(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function ccPreisBlock() {
    if (preisGezeigt || !ccInfo.mass || !motiv) return;
    // Ist der Preisblock in der Section abgeschaltet, existiert das Markup gar
    // nicht — dann auch keinen Fetch auf die Konfigurator-Seite ausloesen.
    var block = root.querySelector('[data-cc-price]');
    if (!block) return;
    var configUrl = (cfg.configUrls || {})[motiv];
    if (!configUrl) return;
    var vollUrl = configUrl + '?view=config-structure';
    fetch(vollUrl)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('http-' + r.status)); })
      .then(function (html) {
        var mA = html.match(/data-klassik-area="([\d.]+)"/);
        if (!mA) return;
        var AF = parseFloat(mA[1]);
        if (!(AF > 0)) return;
        var saleAktiv = html.indexOf('data-final-sale-price') !== -1;
        var W = ccInfo.mass.w / 100, H = ccInfo.mass.h / 100;
        var flaeche = W * H;
        var raw = 5 + AF * Math.pow(flaeche, 0.8) - 5 * H - 10 * W;
        var regulaer = Math.round(raw) + 0.90;
        if (!(regulaer > 0)) return;
        // Sicherheitsabschlag (Alwin 17.08.2026): Die Schätzung soll eher zu niedrig
        // als zu hoch liegen — im Konfigurator darf der echte Preis dann nicht
        // überraschen. Wird auf regulären UND Aktionspreis angewendet, damit die
        // ausgewiesene Ersparnis proportional stimmt. 0 % = exakt der Konfigurator.
        var abschlag = Number(cfg.schaetzAbschlag);
        if (!(abschlag >= 0 && abschlag <= 30)) abschlag = 15;
        regulaer = +(regulaer * (100 - abschlag) / 100).toFixed(2);
        var sizeEl = block.querySelector('[data-cc-price-size]');
        if (sizeEl) sizeEl.textContent = ccInfo.mass.w + ' × ' + ccInfo.mass.h + ' cm';
        var valEl = block.querySelector('[data-cc-price-val]');
        var wasEl = block.querySelector('[data-cc-price-was]');
        var wasVal = block.querySelector('[data-cc-price-was-val]');
        var aktEl = block.querySelector('[data-cc-price-aktion]');
        var chipEl = block.querySelector('[data-cc-price-chip]');
        var pct = Number(cfg.aktionDiscount) || 20;
        // exakt wie der Konfigurator rechnet: (regulaer * DISCOUNT).toFixed(2)
        var eigen = saleAktiv ? +(regulaer * (100 - pct) / 100).toFixed(2) : regulaer;
        if (valEl) valEl.textContent = ccEuro(eigen);
        if (saleAktiv) {
          if (wasVal) wasVal.textContent = ccEuro(regulaer);
          if (wasEl) wasEl.hidden = false;
          if (aktEl) { aktEl.textContent = 'Mit ' + (cfg.aktionName || 'unserer Aktion') + ' nur'; aktEl.hidden = false; }
          if (chipEl) { chipEl.textContent = 'Du sparst ' + Math.round(regulaer - eigen) + ' €'; chipEl.hidden = false; }
        }
        // Materialvergleich: dieselbe Fläche in Aluverbund bzw. ESG-Glas.
        var vgl = block.querySelector('[data-cc-vgl]');
        if (vgl) {
          var alu = Math.round(flaeche * Number(cfg.vglAluQm || 140));
          var glas = Math.round(flaeche * Number(cfg.vglGlasQm || 350));
          if (alu > eigen && glas > alu) {
            var setzen = function (sel, text) { var e = vgl.querySelector(sel); if (e) e.textContent = text; };
            setzen('[data-cc-vgl-own]', ccEuro(eigen));
            setzen('[data-cc-vgl-alu]', 'ca. ' + alu + ' €');
            setzen('[data-cc-vgl-glas]', 'ca. ' + glas + ' €');
            vgl.hidden = false;
          }
        }

        var cta = block.querySelector('[data-cc-price-cta]');
        if (cta) {
          cta.href = vollUrl;
          cta.addEventListener('click', function () { ccTrack('cc_danke_config_click', { motiv: motifName }); });
        }
        block.hidden = false;
        preisGezeigt = true;
        ccTrack('cc_danke_price_shown', { motiv: motifName, sale: saleAktiv });
      })
      .catch(function () { /* kein Preis ist besser als ein falscher */ });
  }

  // Test-Hook: ?ccmass=220x55 simuliert die Maße aus der Foto-Analyse, solange
  // /status die Felder noch nicht liefert (Backend-Patch ausstehend) bzw. zum
  // Draufschauen ohne echten Job. Nur Ziffern, sonst ignoriert.
  try {
    var mm2 = (new URLSearchParams(location.search).get('ccmass') || '').match(/^(\d{2,3})x(\d{2,3})$/);
    if (mm2) { ccInfo.mass = { w: Number(mm2[1]), h: Number(mm2[2]) }; ccPreisBlock(); }
  } catch (e) {}

  // ================= Muster-Block: Box füllen (Rest macht custom.js) =================
  var CLOSE_SVG = '<span class="icon-close" onclick="resetMainProductSelection(event)"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M13.333 13.3334L26.6663 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.667 13.3334L13.3337 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

  function ccFillBox(box, name, finish) {
    var v = (cfg.musterVariants || {})[name + '||' + finish];
    if (!box || !v) return false;
    var bild = v[2] || (cfg.motifImages || {})[name] || '';
    var pb = box.querySelector('.patterns-box');
    if (!pb) return false;
    var alt = pb.querySelector('.patterns-box-img');
    if (alt) alt.remove();
    var pt = box.querySelector('.patterns-text');
    if (pt) pt.innerHTML = name + ' <br>' + finish;
    pb.innerHTML += '<span class="patterns-box-img"><img src="' + bild + '" width="" height="">' + CLOSE_SVG + '</span>';
    box.setAttribute('data-selected-variant-id', v[0]);
    box.setAttribute('data-selected-variant-title', name + ' (' + finish + ')');
    box.setAttribute('data-selected-variant-price', v[1]);
    box.classList.add('filled');
    if (typeof handleSampleProductATCBtnLabel === 'function') handleSampleProductATCBtnLabel();
    if (typeof syncSampleBoxes === 'function') syncSampleBoxes();
    return true;
  }

  // Box 1 mit dem Vorschau-Motiv (Klassik Matt) vorbefüllen — so sind sofort
  // alle drei Boxen samt grüner GRATIS-Box sichtbar (Briefing 3.5).
  function ccPrefill() {
    if (!motiv) return;
    var box = root.querySelector('modal-opener.sample-modal-klassik:not(.filled)');
    if (box) ccFillBox(box, motiv, 'Klassik Matt');
  }
  if (document.readyState !== 'loading') { ccPrefill(); }
  else { document.addEventListener('DOMContentLoaded', ccPrefill); }

  // Klick auf eine Box öffnet den Motiv-Picker (Overlay). Capture-Phase, damit
  // der modal-opener-Button aus global.js nie feuert (sein data-modal existiert
  // hier bewusst nicht). Das X zum Leeren läuft weiter über custom.js.
  var musterRow = root.querySelector('.cc-danke-muster .patterns-blocks-row');
  var ovlTargetBox = null;
  if (musterRow) {
    musterRow.addEventListener('click', function (e) {
      if (e.target.closest('.icon-close')) return;
      var box = e.target.closest('modal-opener.sample-modal-klassik');
      if (!box) return;
      e.preventDefault();
      e.stopPropagation();
      ovlTargetBox = box;
      ovlOpen('box');
    }, true);
  }

  // ================= Vorschau: Etappen-Fortschritt + Reveal =================
  var pv = root.querySelector('[data-cc-preview]');
  if (pv) {
    var pvFill = pv.querySelector('[data-cc-fill]');
    var pvLoading = pv.querySelector('[data-cc-preview-loading]');
    var pvReady = pv.querySelector('[data-cc-ready]');
    var pvImg = pv.querySelector('[data-cc-preview-img]');
    var pvStage = pv.querySelector('[data-cc-stage]');

    var STAGES = [
      { key: 'received',   to: 12, dur: 5,  text: 'Foto empfangen' },
      { key: 'analyzing',  to: 30, dur: 9,  text: 'Küche analysieren' },
      { key: 'generating', to: 97, dur: 55, text: 'Wunschmotiv einsetzen' }
    ];
    var STAGE_IDX = { received: 0, analyzing: 1, generating: 2 };
    var ccdemo = 0;
    try { ccdemo = parseFloat(new URLSearchParams(location.search).get('ccdemo')) || 0; } catch (e) {}
    var pvSpeed = ccdemo > 0 ? ccdemo : 1;
    var pvSi = 0, pvSStart = Date.now(), pvShown = '', pvP = 4;

    // Rückweg aus dem Checkout: fertige Vorschau pro Job im sessionStorage.
    var pvJobId = aktJob;
    var pvCacheKey = pvJobId ? 'cc_preview_' + pvJobId : null;
    var pvRestored = false;

    function ccSetStage(key) {
      var i = STAGE_IDX[key];
      if (typeof i === 'number' && i > pvSi) { pvSi = i; pvSStart = Date.now(); }
    }
    function ccSetText(t) {
      if (!pvStage || t === pvShown) return;
      pvShown = t;
      var wrap = pvStage.parentNode || pvStage;
      wrap.classList.add('cc-danke-stage--fade');
      setTimeout(function () { pvStage.textContent = t; wrap.classList.remove('cc-danke-stage--fade'); }, 220);
    }
    var pvDots = pv.querySelector('[data-cc-dots]');
    var pvDotN = 1, pvDotT = setInterval(function () {
      pvDotN = pvDotN % 3 + 1;
      if (pvDots) pvDots.textContent = '...'.slice(0, pvDotN);
    }, 450);
    var pvT = setInterval(function () {
      var st = STAGES[pvSi];
      var el = (Date.now() - pvSStart) / 1000 * pvSpeed;
      if (pvSi < 2 && el > st.dur * 1.6) { ccSetStage(STAGES[pvSi + 1].key); return; }
      var base = pvSi > 0 ? STAGES[pvSi - 1].to : 4;
      var frac = 1 - Math.exp(-el / (st.dur * 0.6));
      var target = base + (st.to - base) * frac;
      if (target > pvP) pvP = target;
      if (pvFill) pvFill.style.width = Math.min(pvP, 97) + '%';
      var t = st.text;
      if (pvSi === 2) {
        if (pvP > 88) t = 'Vorschau hochladen';
        else if (el > st.dur * 0.62) t = 'Letzter Feinschliff';
      }
      ccSetText(t);
      if (ccdemo && pvSi === 2 && el > st.dur + 6 && imgUrl) window.ccPreviewReveal(imgUrl);
    }, 400);
    // Backend ruft ccPreviewReveal(bildUrl) auf, sobald die KI-Vorschau fertig ist.
    window.ccPreviewReveal = function (url, fromCache) {
      if (url && pvImg) pvImg.src = url;
      if (url && pvCacheKey && !fromCache) { try { sessionStorage.setItem(pvCacheKey, url); } catch (e) {} }
      if (pvFill) pvFill.style.width = '100%';
      if (pvLoading) pvLoading.style.display = 'none';
      if (pvReady) pvReady.hidden = false;
      ccRevealDone = true;
      ccUiUpdate();
      var h1 = root.querySelector('.cc-danke-confirm__h1');
      if (h1) h1.textContent = 'Deine Vorschau ist erstellt.';
      var lead = root.querySelector('.cc-danke-confirm__lead');
      if (lead) lead.textContent = 'Motiv: ' + motifName;
      try { clearInterval(pvT); clearInterval(pvDotT); } catch (e) {}
      if (!fromCache) ccTrack('cc_danke_preview_ready', { motiv: motifName });
    };

    if (pvCacheKey) {
      try {
        var pvCached = sessionStorage.getItem(pvCacheKey);
        if (pvCached) { pvRestored = true; window.ccPreviewReveal(pvCached, true); }
      } catch (e) {}
    }
    // Test-/Vorschau-Hook: ?ccpreview=<bild-url> zeigt direkt den Fertig-Zustand.
    // Nur echte Ergebnis-URLs zulassen.
    try {
      var pvUrl = new URLSearchParams(location.search).get('ccpreview');
      if (pvUrl && pvUrl.indexOf('https://vorschau.danario.de/result/') === 0) window.ccPreviewReveal(pvUrl);
    } catch (e) {}

    // Echtes Backend: ?job=<id> -> Status pollen, bis die KI-Vorschau fertig ist.
    // Derselbe Abruf versorgt Kontingent/Geschwister/Maße (ccStatusDaten).
    try {
      var jobId = pvJobId;
      var apiBase = (cfg.previewApiBase || '').replace(/\/+$/, '');
      if (!jobId) {
        // Der Mail-Link trägt die fertige Vorschau statt einer laufenden Job-ID.
        var mm = (new URLSearchParams(location.search).get('ccpreview') || '').match(/\/result\/([A-Za-z0-9]+)\.(?:png|jpg)/);
        if (mm) jobId = mm[1];
      }
      if (jobId && apiBase && !pvRestored) {
        var tries = 0;
        var poll = setInterval(function () {
          tries++;
          fetch(apiBase + '/status/' + encodeURIComponent(jobId))
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (d && d.phase) ccSetStage(d.phase);
              ccStatusDaten(d);
              if (d && d.status === 'done' && d.url) { clearInterval(poll); window.ccPreviewReveal(d.url); }
              else if (d && d.status === 'error') { clearInterval(poll); ccTrack('cc_danke_preview_error', { job: jobId }); }
            })
            .catch(function () {});
          if (tries > 220) { clearInterval(poll); ccSetText('Dauert etwas länger'); }
        }, 1500);
      } else if (jobId && apiBase) {
        // Vorschau kam aus dem Cache: einmalig Status holen (Kontingent/Maße)
        fetch(apiBase + '/status/' + encodeURIComponent(jobId))
          .then(function (r) { return r.json(); })
          .then(ccStatusDaten)
          .catch(function () {});
      }
    } catch (e) {}
  }

  // Ansichts-Hook fuer Abstimmungen: ?ccdemo3=1 zeigt den Umschalter mit einer
  // dritten Vorschau, ohne echtes Kontingent zu verbrauchen. Reine Optik.
  try {
    if (new URLSearchParams(location.search).get('ccdemo3') === '1') {
      var demoW = root.querySelector('[data-cc-versions]');
      var demoTimer = setInterval(function () {
        if (!demoW || demoW.hidden || demoW.querySelectorAll('button').length !== 2) return;
        clearInterval(demoTimer);
        var vorhanden = Array.prototype.map.call(demoW.querySelectorAll('figcaption'), function (f) { return f.textContent; });
        var name = Object.keys(cfg.motifImages || {}).filter(function (n) { return vorhanden.indexOf(n) < 0; })[0];
        if (!name) return;
        var kopie = demoW.querySelector('button').cloneNode(true);
        kopie.className = '';
        kopie.querySelector('img').src = String(cfg.motifImages[name]).replace(/([?&])width=\d+/, '$1width=240');
        kopie.querySelector('figcaption').textContent = name;
        demoW.appendChild(kopie);
      }, 500);
      setTimeout(function () { clearInterval(demoTimer); }, 20000);
    }
  } catch (e) {}

  // ================= Motiv-Overlay =================
  // Zwei Modi: 'retry' (weiteres Motiv -> /preview-again) und 'box'
  // (Ausführung + Motiv für eine Muster-Box). Set-Modus entfallen (17.08.2026).
  var ZEIGE_EMPFEHLUNG = false;
  var ovl = document.querySelector('[data-cc-overlay]');
  var ovlMode = 'retry';
  // Reihenfolge wie auf der Muster-Seite: erst Ausfuehrung, dann Motiv. Bewusst
  // ohne Vorauswahl — der Kunde soll wahrnehmen, dass es zwei Ausfuehrungen
  // gibt; das Grid darunter bleibt bis dahin gesperrt. Erst dadurch kann das
  // Grid die Bilder der GEWAEHLTEN Ausfuehrung zeigen (Glasoptik sieht anders
  // aus als Klassik Matt). Die Vorschau selbst ist immer Klassik Matt.
  var ovlFinish = null;
  var ovlSucheAn = false;

  function ovlTeil(sel) { return ovl ? ovl.querySelector(sel) : null; }

  function ovlOpen(mode) {
    if (!ovl) return;
    ovlMode = mode;
    ovlFinish = null;
    var title = ovlTeil('[data-cc-overlay-title]');
    var reason = ovlTeil('[data-cc-overlay-reason]');
    var count = ovlTeil('[data-cc-overlay-count]');
    var finish = ovlTeil('[data-cc-overlay-finish]');
    if (title) title.textContent = mode === 'box' ? 'Wähle Dein Muster' : 'Wähle Dein nächstes Motiv';
    if (reason) { reason.textContent = ZEIGE_EMPFEHLUNG ? (ccInfo.reason || '') : ''; reason.hidden = !(ZEIGE_EMPFEHLUNG && mode === 'retry' && ccInfo.reason); }
    if (count) {
      count.hidden = !(mode === 'retry');
      var countText = count.querySelector('[data-cc-overlay-count-text]');
      if (countText) countText.textContent = 'Du hast noch ' + ccMotivText(ccInfo.retries) + ' frei';
    }
    // Ausfuehrungsschritt gibt es nur beim Muster; im retry-Modus ist das Motiv
    // dann der einzige Schritt und traegt die 1.
    if (finish) finish.hidden = mode !== 'box';
    var nrMotiv = ovlTeil('[data-cc-step-motiv]');
    if (nrMotiv) nrMotiv.textContent = mode === 'box' ? '2' : '1';
    ovl.querySelectorAll('[data-cc-finish]').forEach(function (o) { o.classList.remove('is-active'); });
    ovlQuickViewZu();
    ovlGrid();
    if (typeof ovl.show === 'function') ovl.show(); else ovl.hidden = false;
    ccTrack(mode === 'box' ? 'cc_danke_muster_pick_open' : 'cc_danke_retry_open', { motiv: motifName });
  }

  function ovlClose() {
    if (!ovl) return;
    if (typeof ovl.hide === 'function') ovl.hide(); else ovl.hidden = true;
  }

  if (ovl) {
    // Schliessen und ESC uebernimmt modal-dialog selbst (ModalClose-cc-danke).
    ovl.querySelectorAll('[data-cc-finish]').forEach(function (b) {
      b.addEventListener('click', function () {
        ovlFinish = b.getAttribute('data-cc-finish');
        ovl.querySelectorAll('[data-cc-finish]').forEach(function (o) { o.classList.toggle('is-active', o === b); });
        ccTrack('cc_danke_finish_pick', { finish: ovlFinish });
        ovlGrid();   // Motive erst jetzt freigeben — und mit den Bildern dieser Ausfuehrung
        var wrap = ovlTeil('.motiv-wahlen-wrap');
        if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Lupe: Suchfeld ein-/ausblenden — dasselbe Verhalten wie auf der
    // Muster-Seite, deren Handler nur auf .template-sample gebunden wird.
    var lupe = ovlTeil('[data-open-search]');
    var suchForm = ovlTeil('[data-product-picker-form]');
    var stepTitel = ovlTeil('.motiv-wahlen-wrap .picker-step-title');
    if (lupe && suchForm) {
      lupe.addEventListener('click', function () {
        ovlSucheAn = !ovlSucheAn;
        suchForm.style.display = ovlSucheAn ? '' : 'none';
        if (stepTitel) stepTitel.style.display = ovlSucheAn ? 'none' : '';
        var feld = suchForm.querySelector('input[type="search"]');
        if (feld) { if (ovlSucheAn) feld.focus(); else { feld.value = ''; ovlFiltern(''); } }
      });
      suchForm.addEventListener('submit', function (e) { e.preventDefault(); });
      var feld = suchForm.querySelector('input[type="search"]');
      if (feld) feld.addEventListener('input', function () { ovlFiltern(feld.value); });
    }

    // Schnellansicht: custom.js initialisiert Slider und „+ Auswählen"-Buttons
    // nur auf .template-sample. Die Bausteine sind global, also hier nachziehen.
    if (typeof SampleProductQuickViewSlider === 'function') SampleProductQuickViewSlider();
    ovl.querySelectorAll('[data-confirm-motiv]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var wrap = b.closest('[data-variant-id]');
        var name = wrap ? ovlMotivZuVariante(wrap.getAttribute('data-variant-id')) : null;
        ovlQuickViewZu();
        if (name) ovlPick(name);
      });
    });
  }

  // Varianten-ID -> Motivname (Schluessel der Map ist "<Motiv>||<Ausfuehrung>")
  function ovlMotivZuVariante(vid) {
    var vs = cfg.musterVariants || {};
    for (var k in vs) { if (String(vs[k][0]) === String(vid)) return k.split('||')[0]; }
    return null;
  }

  function ovlQuickViewZu() {
    if (!ovl) return;
    var info = ovlTeil('.product-popup-modal__content-info');
    if (info) info.classList.remove('hidden');
    ovl.querySelectorAll('.sample-pro-info-wrap').forEach(function (el) { el.classList.add('hidden'); });
  }

  function ovlFiltern(begriff) {
    var grid = ovlTeil('[data-cc-overlay-grid]');
    if (!grid) return;
    var q = String(begriff || '').trim().toLowerCase();
    grid.querySelectorAll('.grid__item').forEach(function (item) {
      var t = (item.dataset.title || '').toLowerCase();
      item.classList.toggle('hidden', q !== '' && t.indexOf(q) < 0);
    });
  }

  // Kacheln in derselben Struktur wie der Picker der Muster-Seite, damit
  // sample-main-product.css sie identisch stylt. Das Bild richtet sich nach der
  // gewaehlten Ausfuehrung — Deluxe Glasoptik hat eigene Produktbilder.
  function ovlGrid() {
    var grid = ovlTeil('[data-cc-overlay-grid]');
    if (!grid) return;
    var gesperrt = ovlMode === 'box' && !ovlFinish;
    var sperrhinweis = ovlTeil('[data-cc-overlay-sperre]');
    if (sperrhinweis) sperrhinweis.hidden = !gesperrt;
    grid.classList.toggle('cc-danke-grid--gesperrt', gesperrt);
    // Solange gesperrt: Schritt 2 blass, Schritt 1 kraeftig — der Kunde soll auf
    // einen Blick sehen, wo er anfangen muss.
    var motivWrap = ovlTeil('.motiv-wahlen-wrap');
    if (motivWrap) motivWrap.classList.toggle('cc-danke-schritt--wartet', gesperrt);

    grid.innerHTML = '';
    var used = {};
    ccInfo.sibs.forEach(function (sib) { used[sib.motiv] = 1; });
    if (motiv) used[motiv] = 1;
    var namen = Object.keys(cfg.motifImages || {});
    namen.sort(function (a, b) {
      if (ZEIGE_EMPFEHLUNG) {
        var ra = ccInfo.reco.indexOf(a) >= 0 ? 0 : 1;
        var rb = ccInfo.reco.indexOf(b) >= 0 ? 0 : 1;
        if (ra !== rb) return ra - rb;
      }
      return a.localeCompare(b, 'de');
    });
    namen.forEach(function (name) {
      var istUsed = ovlMode === 'retry' && used[name];
      var v = (cfg.musterVariants || {})[name + '||' + (ovlFinish || 'Klassik Matt')] || [];
      var quelle = v[2] || cfg.motifImages[name] || '';
      var kachelUrl = String(quelle).replace(/([?&])width=\d+/, '$1width=360');
      var el = document.createElement('div');
      el.className = 'picker-product grid__item' + (istUsed ? ' cc-danke-motif--used' : '');
      el.setAttribute('data-title', name);
      if (v[0]) el.setAttribute('data-variant-id', v[0]);
      el.innerHTML =
        '<div class="product-info">' +
          '<a class="product-select-btn" href="#" data-cc-select>' +
            '<img class="product-image" loading="eager" decoding="async" src="' + kachelUrl + '" alt="Motiv ' + name + '" width="180" height="180">' +
            '<div class="product-title">' + name + '</div>' +
          '</a>' +
        '</div>';
      var link = el.querySelector('[data-cc-select]');
      if (istUsed || gesperrt) {
        el.title = istUsed ? 'Dieses Motiv hast Du schon getestet' : 'Wähle zuerst die Ausführung';
        link.addEventListener('click', function (e) { e.preventDefault(); });
      } else {
        link.addEventListener('click', function (e) { e.preventDefault(); ovlPick(name); });
      }
      // Schnellansicht nur, wenn es fuer die Variante ueberhaupt Inhalte gibt.
      if (!gesperrt && v[0] && ovl.querySelector('.sample-pro-info-wrap[data-variant-id="' + v[0] + '"]')) {
        var qv = document.createElement('a');
        qv.className = 'product-view-btn';
        qv.href = '#';
        qv.innerHTML = '<span class="product-view-svg-wrap"></span><span>Schnellansicht</span>';
        var ikon = ovlTeil('[data-cc-qv-icon]');
        if (ikon) qv.querySelector('.product-view-svg-wrap').appendChild(ikon.content.cloneNode(true));
        qv.addEventListener('click', function (e) {
          e.preventDefault();
          if (typeof handleSampleProductQuickView === 'function') handleSampleProductQuickView(e);
        });
        el.appendChild(qv);
      }
      grid.appendChild(el);
    });
  }

  function ovlPick(name) {
    if (ovlMode === 'box') {
      if (!ovlFinish) return;   // ohne Ausfuehrung keine Auswahl
      var box = ovlTargetBox && document.body.contains(ovlTargetBox)
        ? ovlTargetBox
        : root.querySelector('modal-opener.sample-modal-klassik:not(.filled)');
      // Eine bereits gefüllte Box wird ersetzt: Attribute überschreibt ccFillBox.
      if (box) {
        ccFillBox(box, name, ovlFinish);
        ccTrack('cc_danke_muster_pick', { motiv: name, finish: ovlFinish });
      }
      ovlTargetBox = null;
      ovlClose();
      return;
    }
    ovlRetry(name);
  }

  function ovlRetry(name) {
    var base = (cfg.previewApiBase || '').replace(/\/+$/, '');
    if (!base || !aktJob) { ovlClose(); return; }
    ccTrack('cc_danke_retry_pick', { motiv: name });
    fetch(base + '/preview-again', {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ job: aktJob, motiv: name })
    })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r && r.ok && r.job_id) {
          window.location.href = location.pathname + '?motiv=' + encodeURIComponent(name) + '&job=' + encodeURIComponent(r.job_id);
        } else {
          ccInfo.retries = 0; ccUiUpdate(); ovlClose();
        }
      })
      .catch(function () { ovlClose(); });
  }

  var retryOpen = root.querySelector('[data-cc-retry-open]');
  if (retryOpen) retryOpen.addEventListener('click', function (e) { e.preventDefault(); ovlOpen('retry'); });
})();
